var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenChrome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Download_green_icon",
    "data-name": "Download green icon",
    d: "M7.437,1.428A.838.838,0,0,0,6.392.561s.314-.089-.038.011A8.108,8.108,0,0,0,.5,8.4a8.062,8.062,0,0,0,8,8.123,8.062,8.062,0,0,0,8-8.123A8.108,8.108,0,0,0,10.629.566c-.347-.1-.021-.006-.021-.006a.842.842,0,0,0-1.045.867v6.79c0,.15.084.185.189.078,0,0,.862-.878,1.172-1.2a1.073,1.073,0,1,1,1.513,1.521L9.18,11.912a.936.936,0,0,1-1.326,0l-3.29-3.3a1.073,1.073,0,0,1,1.5-1.532C6.385,7.417,7.248,8.3,7.248,8.3c.1.106.189.071.189-.078Z",
    transform: "translate(-0.5 -0.521)",
    fill: "#7be832",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenChrome);
export default __webpack_public_path__ + "static/media/greenChrome.9042aa9c2de5547e4d2f62515202f8e4.svg";
export { ForwardRef as ReactComponent };